import React, { useCallback } from "react";
import { selectStores, selectUsersXStores } from "../users-selectors";
import {
  Checkbox,
  FormControlLabel,
  List,
  ListItemText,
  Paper,
  Stack,
} from "@mui/material";
import { Body1, H6 } from "../../../../components";
import { useDispatch, useSelector } from "react-redux";
import {
  usersXStoreAdd,
  usersXStoreDelete,
} from "../reducers/users-page-actions";
import InputBusca from "../../../../components/input-busca";

const STR = {
  titleUsersXStores: "Usuários x Lojas",
  subtitleUsersXStores: "Atribuição e retirada de lojas aos usuários",
};

const storeInUser = (userId, storeId, usersXStores) => {
  if (!usersXStores.hasOwnProperty(userId)) return false;
  return usersXStores[userId].includes(storeId);
};

function UsersXStores({ id }) {
  const [filter, setFilter] = React.useState("");
  const dispatch = useDispatch();
  const stores = useSelector(selectStores);
  const usersXStores = useSelector(selectUsersXStores);
  //
  const toggleStoreInUser = useCallback(
    (value, storeId) => {
      if (value) {
        dispatch(
          usersXStoreAdd({
            id_usuario: id,
            id_loja: storeId,
          })
        );
      } else {
        dispatch(
          usersXStoreDelete({
            id_usuario: id,
            id_loja: storeId,
          })
        );
      }
    },
    [dispatch, id]
  );

  let storesInFilter = [];
  if (filter) {
    storesInFilter = stores.filter(
      (store) =>
        store.loja.toLowerCase().includes(filter.toLowerCase()) ||
        store.endereco.toLowerCase().includes(filter.toLowerCase())
    );
  } else {
    storesInFilter = stores;
  }
  return (
    <Stack>
      <H6>{STR.titleUsersXStores}</H6>
      <Body1 align="center">{STR.subtitleUsersXStores}</Body1>
      <InputBusca
        variant="filled"
        label=""
        filtro={filter}
        setFiltro={setFilter}
        desativarPesquisaLenta
        sx={{ mb: 0.5 }}
      />
      <List disablePadding dense>
        {storesInFilter.map((inStore) => (
          <Paper key={inStore.id} sx={{ p: 0.5, my: 0.5 }}>
            <StoreItem
              name={inStore.loja}
              description={inStore.endereco}
              id={inStore.id}
              onToggle={toggleStoreInUser}
              isChecked={
                usersXStores ? storeInUser(id, inStore.id, usersXStores) : false
              }
            />
          </Paper>
        ))}
      </List>
      <br />
      <br />
    </Stack>
  );
}

const StoreItem = ({ id, name, description, isChecked, onToggle }) => {
  return (
    <FormControlLabel
      checked={isChecked}
      onChange={(e) => onToggle(e.target.checked, id)}
      control={<Checkbox size="small" />}
      label={<ListItemText primary={name} secondary={description} />}
    />
  );
};

export default UsersXStores;
